import React, { useState } from "react";
import { update } from "../_request";
import { useTranslation } from "react-i18next";
import { useToast } from "../../modules/layout/components/ToastContext";
import { useNavigate } from "react-router-dom";

interface ApproveProfileProps{
    targetProfileId: string;
    uniqueId?: string;
    onSuccess: () => void;
}

export default function ApproveProfile({targetProfileId, uniqueId, onSuccess}: ApproveProfileProps){
    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    const [open, setOpen] = useState(false);

    const handleApprove = async () => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try{
            setLoading(true);
            const params = new URLSearchParams({ targetProfileId });

            if (uniqueId) { params.append("uniqueId", uniqueId); }

            const result: any = await update( `/api/UserEvents/MarkProfileAsApproved?${params.toString()}`, null );
            const respStatus = result?.status ?? result?.response?.status;     
        
            if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast && showToast(t('ProfileApprovedSuccessfully'), 'success');
                onSuccess();
            } else if (respStatus === 401) {
                 navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403');
            } else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotFound'), 'error');
            } else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast && showToast(t('StatusCode', { code: String(respStatus) }), 'error');
            }
        } catch (err: any){
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
        setLoading(false);
        setOpen(false);
      }
    }

    return(
        <>
            <button className="btn gg-btn  me-2 "
                    onClick={()=>setOpen(true)}
                    disabled={loading}>
                {t('ApproveProfile')}
            </button>


            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className="mb-0">
                                {t('ApproveProfile')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                {t('ApprovingWillActivate')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button
                                className="gg-btn"
                                onClick={() => setOpen(false)}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button
                                className="btn btn-secondary text-white"
                                onClick={handleApprove}
                                disabled={loading}
                            >
                                {loading ? t('Approving') : t('Confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};